
import { Vue } from "vue-class-component";

export default class FabHelpButton extends Vue {

}
